export default "__VITE_ASSET__Cdmw662G__"